// THE PASSWORD RULE, as the browser knows it. One number, one message, every screen that
// lets someone choose a password: sign-up (RegisterPage), the reset link (ResetPasswordPage),
// the profile page (ProfilePage) and an admin typing one for an employee
// (AddEditEmployeeDialog).
//
// ⚠️ The SERVER is what enforces it — `backend/auth.py` MIN_PASSWORD_LENGTH and
// `password_refusal`. This constant only decides what the form says and what the browser
// blocks early. If the two ever disagree the server wins and the customer sees a confusing
// refusal — which is what was happening until 14/09/2026, when three screens said 6 or 8
// and the API said 12 (BUGS.md). `credentialFields.checks.mjs` fails if the number here
// stops matching the backend, or if any of the four screens stops importing it.
export const MIN_PASSWORD_LENGTH = 12;

export const PASSWORD_HINT = `Minimum ${MIN_PASSWORD_LENGTH} characters`;

/** The message to show when a typed password is too short, or null if it is fine. */
export function passwordTooShort(password) {
  return (password || '').length < MIN_PASSWORD_LENGTH
    ? `Your password needs to be at least ${MIN_PASSWORD_LENGTH} characters.`
    : null;
}
